<template>
  <p class="subtitle-link">
    <button style="color: #2d5796" @click="onClickUpdateInfo">
      <v-icon size="16px" style="color: #2d5796">mdi-refresh</v-icon> Atualização realizada
    </button>
    em {{ lastProcessData }}
  </p>
</template>

<script>
export default {
  emits: ['click'],
  props: {
    lastProcessData: {
      type: String,
      required: true,
    },
  },

  methods: {
    onClickUpdateInfo(e) {
      e.preventDefault();
      this.$emit('click', e);
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  font-size: $font-size-xxxs;
  font-weight: $font-weight-regular;
  color: $feedback-color-information-dark;
}

p {
  color: $neutral-color-high-medium;
  font-size: $font-size-xxxs;
  font-weight: $font-weight-regular;
  margin-bottom: 0;

  span {
    margin-left: 2px;
  }
}
</style>
